jQuery(function($){

  $('body').on('click', '.toggle-click', function() {
    // alert('clicked');
    $(this).parent().toggleClass('open-items');
  });


  if($('#jw_half_metre_qty_wrapper').length >0){
    $('#shopify_quantity_fake .plus').click(function(){
    
      var current_value = parseFloat($('#jw_qty_fake').val());
      if(!current_value || current_value < 0.5){
        current_value = 0.5;
      }
      current_value = current_value + 0.5;
    
     
      var final_value = parseFloat(current_value);
      $('#jw_qty_fake').val(final_value);
      jw_setup_price_and_qty();
       //console.log('dd=========');
    });
 

   $('#shopify_quantity_fake .minus').click(function(){
    
      var current_value = parseFloat($('#jw_qty_fake').val());
      if(!current_value || current_value < 0.5){
        current_value = 0.5;
      }
      current_value = current_value - 0.5;
    
     
      var final_value = parseFloat(current_value);
      if(final_value < 0.5){
        final_value = 0.5;
      }
     
      $('#jw_qty_fake').val(final_value);
     jw_setup_price_and_qty();
      //console.log('ttt=========');
    });
  }//end of #jw_half_metre_qty_wrapper

  $('#shopify_quantity_fake').on('keyup', '#jw_qty_fake', function() {
    jw_setup_price_and_qty();
  });

  function jw_setup_price_and_qty(){
     //console.log('xxx=========');
    var jw_qty_fake = parseFloat($('#jw_qty_fake').val());
    if(!jw_qty_fake || jw_qty_fake < 0.5){
      jw_qty_fake = 0.5;
    }

    var jw_my_qty = Math.floor(jw_qty_fake / 0.5);
   // console.log(jw_my_qty+'=========');
    if(!jw_my_qty || jw_my_qty <1){
      jw_my_qty = 1;
    }

   
    //set up qty
    $('#jw_half_metre_qty').val(jw_my_qty);

   // var jw_half_metre_unit_price = $('#jw_half_metre_unit_price').val();

    //get unit price with current convert
     var jw_half_metre_unit_price_with_currency = $('#jw_half_metre_unit_price_with_currency span:last').html();
     var jw_half_metre_unit_price = Number(jw_half_metre_unit_price_with_currency.replace(/[^0-9\.-]+/g,""));
    var my_flag = jw_half_metre_unit_price_with_currency.replace(/[\d\., ]/g, '');
   // console.log(my_unit_price);
    
    var total_price = parseFloat(jw_half_metre_unit_price * jw_my_qty);
    var total_price_final = total_price.toFixed(2);
   // console.log(total_price_final);
    if(!total_price_final || total_price_final < 0){
      total_price_final = jw_half_metre_unit_price;
    }

    //var my_flag = $('#jw_dynamic_price > span').data('currencyt4s');
    //console.log(my_flag);
    $('#jw_dynamic_price span').html(my_flag + '' + total_price_final);

      var jw_text_unit = '';
    if(jw_my_qty == 1){
      jw_text_unit = '1 unit';
    }else{
      jw_text_unit = jw_my_qty + ' units';
    }
    
    $('#single_variation_wrap_left_inner_text_unit').html(jw_text_unit);
    $('#single_variation_wrap_left_inner_text_metre').html(jw_qty_fake);
    
  }

  // $(".product-form__cart-submit").click(function(i) {
  //   i.preventDefault();
  //   $(".product-form").submit();
  // })


  if($('.jw-nav-back').length > 0){
    $('.jw-nav-back').on('click', function(e) {
       e.preventDefault(); // Prevent default link behavior

    const href = $(this).attr('href');

    if (window.history.length > 1) {
        history.go(-1);
    } else if (href && href !== '#') {
        // Fallback to href if there's no history
        window.location.href = href;
    } else {
        // Optional: default fallback if no href or history
        window.location.href = '/';
    }
    
  });

  }
})
/* >>>>> SCF HALF-METRE CART — type-to-enter metres (mini-cart drawer) >>>>>
   The visible .jw-metre-input holds a metre value; on change we snap to 0.5 m,
   convert to whole Shopify units (metres / 0.5) and write them into the native
   [data-quantity-value] input, then fire its native change so the theme runs its
   normal cart update + re-render. Delegated on document so it survives the
   drawer's AJAX re-renders. To remove: delete this block. */
;jQuery(function ($) {
  function jwCommitMetre(inp) {
    var wrap = inp.closest('[data-quantity-wrapper]');
    if (!wrap) { return; }
    var unit = wrap.querySelector('[data-quantity-value]');
    if (!unit) { return; }
    var cur = parseInt(unit.value, 10) || 0;
    var min = parseInt(unit.getAttribute('min'), 10); if (!min || min < 1) { min = 1; }
    var max = parseInt(unit.getAttribute('max'), 10); if (!max) { max = 9999; }
    var metres = parseFloat(String(inp.value).replace(',', '.'));
    if (isNaN(metres) || metres <= 0) { inp.value = (cur || min) * 0.5; return; }
    var units = Math.round(metres / 0.5);          /* snap to 0.5 m */
    if (units < min) { units = min; }
    if (units > max) { units = max; }
    inp.value = units * 0.5;                        /* reflect the snapped value */
    if (units === cur) { return; }                 /* no quantity change */
    unit.value = units;
    unit.dispatchEvent(new Event('input',  { bubbles: true }));
    unit.dispatchEvent(new Event('change', { bubbles: true }));
  }
  $(document).on('change', '.jw-metre-input', function () { jwCommitMetre(this); });
  $(document).on('keydown', '.jw-metre-input', function (e) {
    if (e.key === 'Enter' || e.keyCode === 13) { e.preventDefault(); this.blur(); }
  });
  $(document).on('focus', '.jw-metre-input', function () {
    var el = this; setTimeout(function () { try { el.select(); } catch (x) {} }, 0);
  });
});
/* <<<<< SCF HALF-METRE CART — type-to-enter metres <<<<< */